export default __webpack_public_path__ + "static/media/CamelCoding-logo.b9be81f1.svg";